// src/services/api/messageCenterShiftTypes.js
import { apiClient } from './base';

export const getShiftTypes = async (params = {}) => {
  try {
    const response = await apiClient.get('/message-center/shift-types', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getShiftTypeById = async (id) => {
  try {
    const response = await apiClient.get(`/message-center/shift-types/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createShiftType = async (data) => {
  try {
    const response = await apiClient.post('/message-center/shift-types', data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateShiftType = async (id, data) => {
  try {
    const response = await apiClient.put(`/message-center/shift-types/${id}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
